/**
 * noneCRM — CRMPort adapter that reports "not connected" for everything.
 *
 * Used when no CRM is wired. Real adapters (ghl, hubspot, salesforce)
 * implement the same port.
 */
export function createNoneCRM() {
  return {
    async status() {
      return { status: "not_connected", vendor: "none" };
    },
    async connect() {
      return { ok: false, message: "CRM adapter not configured. See adapters/crm/README.md" };
    },
    async disconnect() { /* no-op */ },
    async syncActors() { return []; },
    async syncSignals() { return []; },
    async pushOutcome() { return { ok: false }; },
    async pushActorUpdate() { return { ok: false }; },
    subscribeToSignals() { return () => {}; },
    async resolveContact() { return { status: "not_configured", contactId: null, candidates: [] }; },
  };
}
